import { networkCall } from "../../../../../utils/network-call/network-call";

export const MaintainerUserListLoader = async () => {
    const getUsersResponse = await networkCall('/users');
    return { getUsersResponse };
};